var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCircleLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 283,
    viewBox: "0 0 215 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 131.5,
    r: 125,
    stroke: "url(#paint0_linear_1_400)",
    strokeOpacity: 0.36,
    strokeWidth: 53
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_400",
    x1: 151.5,
    y1: -20,
    x2: 151.5,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#2A2873"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCircleLogin);
export default __webpack_public_path__ + "static/media/bg-circle-login.07be94355a51a8dd13bd951e7475b1ca.svg";
export { ForwardRef as ReactComponent };